import React, { useContext, useEffect, useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import AdminTable from "../AdminTable/AdminTable";
import { apisPath, paths } from "../../../utils/path";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import "../../../styles/Layout/Admin_Styles/_AdminSearchDetails.scss";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { authHttp } from "../../services/utility";
import CandidateInfoModal from "../CandidateInfoModal/CandidateInfoModal";
import { AuthContext } from "../../../context/AuthContext";
import { encrypt } from "../../../utils/encryptDecrypt";
import { fDate } from "../../../utils/formatTime";
import { useNavigate } from "react-router-dom";
import { appPrefix } from "../../../utils/helpers";

const TableHeadData = [
  {
    id: "application_no",
    label: "Application number",
    alignItems: 'left',
    link: true,
    type: "link",
  },
  { id: "name", label: "Candidate Name", decrypt: true, alignItems: 'left' },
  { id: "posts", label: "Exam Name", isArray: true, alignItems: 'left' },
  { id: "father_name", label: "Father name", decrypt: true, alignItems: 'left' },
  { id: "dob", label: "DOB", date: true, format: "dd/MM/yyyy", alignItems: 'left' },
  { id: "email", label: "Email ID", decrypt: true, alignItems: 'left' },
  { id: "cancel", label: "Cancelled", alignItems: 'left' },
  { id: "payment_status", label: "Status", status: true, alignItems: 'left' },
];

const defaultSearchValues = {
  email: "",
  name: "",
  father_name: "",
  dob: null,
  submitted_date: null
};

const Payment = () => {
  const { setIsLoading, setAlertState, setIsTableLoading } =
    useContext(AuthContext);
  const [data, setData] = useState([]);
  const navigate = useNavigate()
  // const [pageNum, setPageNum] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [paginationData, setPaginationData] = useState({
    currentPage: 0,
    totalRecord: 0,
    rowsPerPage: 10,
  });
  const [searchData, setSearchData] = useState(defaultSearchValues);

  const [finalSearchData, setFinalSearchData] = useState(defaultSearchValues);

  useEffect(() => {
    setIsLoading(true);
    setIsTableLoading(true);
    if (paginationData?.currentPage !== undefined) {
      getData(paginationData?.currentPage + 1, finalSearchData);
    }
  }, []);

  const handleOpen = (id, type) => {
    if (type === "modal") {
      setIsLoading(true);
      setSelectedId(id);
      setOpen(true);
    }
    if (type === "link") {
      navigate(
        `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidateInfo}`,
        { state: id }
      );
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId("");
  };

  const getData = async (page, tempSearch) => {
    authHttp
      .post(apisPath?.admin?.payment + `?page=${page}`, tempSearch)
      .then((res) => {
        // console.log("search by data:" + res?.data?.data);
        const tempData = res?.data?.data;
        tempData.map((user) => {
          const tempPost = user?.posts.map((post) => {
            return post?.name;
          });
          user.posts = tempPost;

          if (String(user?.is_cancel) === '2') {
            user.cancel = 'Yes'
          }
          else {
            user.cancel = 'No'
          }

          if (user?.payment_status === 'Success') {
            user.payment_status = 'Paid'
            user.className = 'success'
          }
          else {
            user.payment_status = 'Not Paid'
            user.className = 'fail'
          }
        });
        setData(tempData);
        setPaginationData((prev) => ({
          ...prev,
          totalRecord: res?.data?.totalusersCount,
          rowsPerPage: res?.data?.resultperpage,
        }));
        setIsLoading(false);
        setIsTableLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const searchValuesHandler = (key, value) => {
    setSearchData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const searchHandler = () => {
    const tempSearchValue = {
      ...searchData,
      name: searchData?.name
        ? encrypt(searchData?.name.toUpperCase())
        : searchData?.name,
      father_name: searchData?.father_name
        ? encrypt(searchData?.father_name.toUpperCase())
        : searchData?.father_name,
      email: searchData?.email
        ? encrypt(searchData?.email.toLowerCase())
        : searchData?.email,
      mobile: searchData?.mobile
        ? encrypt(searchData?.mobile)
        : searchData?.mobile,
      submitted_date: searchData?.submitted_date ? fDate(searchData?.submitted_date, 'dd/MM/yyyy') : null,
      application_no: searchData?.application_no ? searchData?.application_no.replace(appPrefix, '') : ''
    };
    setPaginationData((prev) => ({
      ...prev,
      currentPage: 0,
    }));
    setIsTableLoading(true);
    getData(1, tempSearchValue);
    setFinalSearchData(tempSearchValue);
  };

  const pageChangeHandler = (page) => {
    setIsTableLoading(true);
    getData(page + 1, finalSearchData);
    setPaginationData((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  return (
    <div className="admin-search--details">
      <div className="admin-search--details__header">
        <h2>Payment</h2>
      </div>
      {/* {JSON.stringify(searchData)} */}
      <div className="admin-search--details__card">
        <Grid container spacing={3} alignItems="center">
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Email ID/Mobile No."
                variant="outlined"
                onChange={(e) => {
                  if (Number(e.target.value)) {
                    searchValuesHandler("email", '');
                    searchValuesHandler("mobile", e.target.value);
                  }
                  else {
                    searchValuesHandler("mobile", '');
                    searchValuesHandler("email", e.target.value);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  autoComplete="off"
                  fullWidth
                  views={["year", "month", "day"]}
                  label="Submitted Date"
                  inputFormat="DD/MM/YYYY"
                  name="submitted_date"
                  value={searchData?.submitted_date}
                  onChange={(e) => {
                    searchValuesHandler("submitted_date", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      autoComplete="off"
                      fullWidth
                      {...params}
                      onDrop={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Name"
                variant="outlined"
                onChange={(e) => {
                  searchValuesHandler("name", e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Father Name"
                variant="outlined"
                onChange={(e) => {
                  searchValuesHandler("father_name", e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  autoComplete="off"
                  fullWidth
                  views={["year", "month", "day"]}
                  label="DOB"
                  inputFormat="DD/MM/YYYY"
                  name="dob"
                  value={searchData?.dob}
                  onChange={(e) => {
                    searchValuesHandler("dob", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      autoComplete="off"
                      fullWidth
                      {...params}
                      onDrop={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Application No."
                variant="outlined"
                onChange={(e) => {
                  searchValuesHandler("application_no", e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item lg={1.5} md={1.5} sm={6} xs={12}>
            <div className="admin-search--details__button">
              <Button variant="contained" onClick={searchHandler}>
                Search
              </Button>
            </div>
          </Grid>
        </Grid>
        <div className="payment-table">
          <AdminTable
            tableHead={TableHeadData}
            pageChangeHandler={pageChangeHandler}
            data={data}
            paginationData={paginationData}
            handleOpen={handleOpen}
          />
        </div>
      </div>
      {open && (
        <CandidateInfoModal
          open={open}
          handleClose={handleClose}
          selectedId={selectedId}
        />
      )}
    </div>
  );
};

export default Payment;
